import { render, staticRenderFns } from "./card-grid.vue?vue&type=template&id=6b54974c"
var script = {}
import style0 from "./card-grid.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports